module.exports = __webpack_public_path__ + "img/tao.830e358b.jpg";